<template>
	<div class="c-chatbot">
		<div
			class="c-chatbot__cont"
			:class="[
				`open-state-dfy--${data.openStateDFY}`,
				`open-state-dflat--${data.openStateDFlat}`,
				`open-state-dflatSeongsu--${data.openStateDFlatSeongsu}`,
				data.isLangKr ? 's--kr' : ''
			]">
			<div class="cover"></div>
			<div class="c-chatbot__bg" @click="methods.toggleChatbot()"><div>chatbot background</div></div>
			<keep-alive>
				<component v-bind:is="data.componentName"></component>
			</keep-alive>
		</div>
		<button class="c-chatbot__btn-box" :class="{'c-chatbot__btn-box--hide': data.hiddenOnLoading }" @click="methods.toggleChatbot()">
			<div class="c-chatbot__btn-wrap">
				<div class="c-chatbot__btn i-chatbot"></div>
				<div class="c-chatbot__btn-face">
					<Avatar :avatarName="data.avatarName" :type="'big'" :fixed="true"/>
				</div>
			</div>
			<img class="c-chatbot__shadow" src="@/assets/chatbot/animate_avatar_ann_shadow.png" alt="">
		</button>
	</div>
</template>

<script>
import * as $ from "fxdom";
import * as _ from "fxjs";
import { reactive, computed, watch, onMounted, onUnmounted, useStore } from "@/helper/vue.js";
import { addEvent, removeEvent } from "@/helper/event.js";
import { mobileScrollLock } from "@/helper/gadget.js";
import { isLoaderOn } from "@/store/appSettings.js";
import Main from './_ChatMain.vue';
import Avatar from './type/_Avatar.vue';

export default {
  components: {
		Avatar,
		'Main': Main,
  },
  setup() {
    const { state, get, commit, dispatch } = useStore();
    const data = reactive({
      isLangKr: computed(() => state.isLangKr),
      // openS!tate: computed(() => state.chatbot.openSt!ate),
			openStateDFY: computed(() => state.chatbot.openStateDFY),
			openStateDFlat: computed(() => state.chatbot.openStateDFlat),
			openingHoursDFY: computed(() => state.chatbot.openingHoursDFY),
			openingHoursDFlat: computed(() => state.chatbot.openingHoursDFlat),
      getItems: computed(() => get["chatbot/getItems"]),
			componentName: null,
			avatarName: 'ann',
			hiddenOnLoading: computed(() => get["hiddenOnLoading"]),
			isChatOpen: false
    });

    const methods = {
			// mobileScrollLock,
			toggleChatbot: () => {
				// data.isChatOpen = !data.isChatOpen
				// let y = window.pageYOffset

				// Mobile Agent 일 때 body, app Scroll Lock
				if (state.isMobileAgent) {
					$.toggleClass("chat-body-lock", $.qs("body"));
					$.toggleClass("scroll-lock", $.qs(".app"));
				}

				$.toggleClass("c-chatbot--open", $.qs(".c-chatbot"));
				data.componentName = 'Main';
				if (!state.chatbot.mainComponent) {
					commit('chatbot/renderMainComponent');
				}

				//mobileScrollLock(lockTarget, y, data.isChatOpen)
			},
    };

    onMounted(() => {
			window.addEventListener("prepare.enter", () => {
				$.removeClass("c-chatbot--open", $.qs(".c-chatbot"));
			});
			console.log("⛰ Chatbot.vue");
			const chatBtn = $.qs(".c-chatbot__btn-box")
			chatBtn.addEventListener('mouseenter', e => {
				data.avatarName = 'annH'
			});
			chatBtn.addEventListener('mouseleave', e => {
				data.avatarName = 'ann'
			});

      watch(
        () => state.chatbot.mainComponent,
        (curr, prev) => {
					if (state.chatbot.mainComponent) {
						data.componentName = 'Main';
					}
        }
      );
		});

    return {
      data,
			methods,
    }
  }
}
</script>

<style lang="scss" src="@/css/chatbot.scss"></style>
<style>@font-face { font-family: 'D2K21-CHATBOT'; src: url('./chatbot-icon/fonts/D2K21-CHATBOT.ttf?h5s1g') format('truetype'), url('./chatbot-icon/fonts/D2K21-CHATBOT.woff?h5s1g') format('woff'), url('./chatbot-icon/fonts/D2K21-CHATBOT.svg?h5s1g#D2K21-CHATBOT') format('svg'); font-weight: normal; font-style: normal; font-display: block; } [class^="ico-chatbot--"], [class*=" ico-chatbot--"] { /* use !important to prevent issues with browser extensions that change fonts */ font-family: 'D2K21-CHATBOT' !important; speak: never; font-style: normal; font-weight: normal; font-variant: normal; text-transform: none; line-height: 1; /* Better Font Rendering =========== */ -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; } .ico-chatbot--input-check:before { content: "\e924"; color: #ebe3d7; } .ico-chatbot--content-cancel:before { content: "\e900"; } .ico-chatbot--content-clear:before { content: "\e901"; color: #d2330f; } .ico-chatbot--content-collections:before { content: "\e902"; } .ico-chatbot--content-done:before { content: "\e903"; color: #0aa86c; } .ico-chatbot--content-favorite--border:before { content: "\e904"; } .ico-chatbot--content-favorite:before { content: "\e905"; } .ico-chatbot--content-file:before { content: "\e906"; } .ico-chatbot--content-info:before { content: "\e907"; } .ico-chatbot--content-language:before { content: "\e908"; } .ico-chatbot--content-lock:before { content: "\e909"; } .ico-chatbot--content-mail:before { content: "\e90a"; } .ico-chatbot--content-place--pin:before { content: "\e90b"; } .ico-chatbot--content-place:before { content: "\e90c"; } .ico-chatbot--content-time:before { content: "\e90d"; } .ico-chatbot--media-pause--black:before { content: "\e90e"; } .ico-chatbot--media-pause--circle:before { content: "\e90f"; } .ico-chatbot--media-play--arrow:before { content: "\e910"; } .ico-chatbot--media-play--circle:before { content: "\e911"; } .ico-chatbot--media-replay:before { content: "\e912"; } .ico-chatbot--media-skip--next:before { content: "\e913"; } .ico-chatbot--media-skip--previous:before { content: "\e914"; } .ico-chatbot--media-videocam:before { content: "\e915"; } .ico-chatbot--media-volume--mute:before { content: "\e916"; color: #f9f5ef; } .ico-chatbot--media-volume--off:before { content: "\e917"; } .ico-chatbot--media-volume--up:before { content: "\e918"; } .ico-chatbot--navi-arrow--back:before { content: "\e919"; } .ico-chatbot--navi-arrow--forward:before { content: "\e91a"; } .ico-chatbot--navi-arrow--ne:before { content: "\e91b"; } .ico-chatbot--navi-arrow--se:before { content: "\e91c"; } .ico-chatbot--navi-expand--less:before { content: "\e91d"; } .ico-chatbot--navi-expand--more:before { content: "\e91e"; } .ico-chatbot--navi-navigate--back:before { content: "\e91f"; } .ico-chatbot--navi-navigate--next:before { content: "\e920"; } .ico-chatbot--social-behance:before { content: "\e921"; } .ico-chatbot--social-facebook:before { content: "\e922"; } .ico-chatbot--social-instagram:before { content: "\e923"; } </style>